import { Typography } from "./typography";
import { articleEyebrowClassName } from "./article-typography";

type Props = {
  eyebrow: string;
};

/**
 * Eyebrow / category label above the article. The headline is the first H1 in
 * the content, so the eyebrow stays a plain label.
 */
export const ArticlePageHeader = ({ eyebrow }: Props) =>
  eyebrow ? (
    <Typography weight="bold" className={articleEyebrowClassName}>
      {eyebrow}
    </Typography>
  ) : null;
